import { takeLatest, call, put } from "redux-saga/effects";

import apiCaller from "../../utils/apiCaller";
import {
  GET_INSTRUMENTS_REQUEST,
  getInstrumentsSuccess,
  getInstrumentsFail,
  EDIT_INSTRUMENT_REQUEST,
  editInstrumentSuccess,
  editInstrumentFail
} from "../actions/instruments";
import { HTTP_METHODS } from "../../config";

function* getInstruments({ payload: { onSuccess, onError } }) {
  try {
    const response = yield call(apiCaller, HTTP_METHODS.GET, {
      url: "/api/admin/instruments",
      token: true
    });

    if (onSuccess) {
      yield call(onSuccess);
    }

    const successAction = yield call(getInstrumentsSuccess, response);
    yield put(successAction);
  } catch (err) {
    if (onError) {
      yield call(onError);
    }

    const errAction = yield call(getInstrumentsFail, err);
    yield put(errAction);
  }
}

function* editInstrument({ payload: { id, data, onSuccess, onError } }) {
  try {
    const requestPayload = {
      url: `/api/admin/instruments/${id}`,
      payload: {
        instrument: data
      },
      token: true
    };

    const response = yield call(apiCaller, HTTP_METHODS.PUT, requestPayload);

    if (onSuccess) {
      yield call(onSuccess);
    }

    const successAction = yield call(editInstrumentSuccess, response);
    yield put(successAction);
  } catch (err) {
    if (onError) {
      yield call(onError);
    }

    const errAction = yield call(editInstrumentFail, err);
    yield put(errAction);
  }
}

export default function* () {
  yield takeLatest(GET_INSTRUMENTS_REQUEST, getInstruments);
  yield takeLatest(EDIT_INSTRUMENT_REQUEST, editInstrument);
}
